<template>
    <section>
        <div class="main_section2" style="display: flex; position: relative; ">
            <div class="mobile_con_wrap" style="display: flex; flex-direction: column; padding-top: 163px; overflow-x: hidden;">
                <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-bottom: 200px;">
                    <p data-aos="fade-up"
                        data-aos-delay="0"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" style="font-size: 30px; font-weight: 700; color: white; text-align: center; color: #000000; margin-bottom: 28px;">
                        우리의 생각은요..
                    </p>
                    <p data-aos="fade-up"
                        data-aos-delay="100"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" style="font-size: 15px; font-weight: 400; text-align: center; color: #5A5A5A; line-height: 2;">
                        필드유 팀원들은 이렇게 생각하고 임하고 있습니다.<br>
                        우리가 지향하는 바를 잊지 않고<br>
                        크고 작은 성과들을 달성해나가면<br>
                        어느새 우리는 우리가 목표하는 곳에<br>
                        다다를 수 있을 것입니다. 우리는 교육의 혁신을<br>
                        이루어내고자 함께 모였으며,<br>
                        앞으로도 우리는 고민하고,<br>
                        답을 찾을 것입니다.
                        <!-- 필드유 팀원들은 이렇게 생각하고 임하고 있습니다.
                        우리가 지향하는 목표를 계속 잊지 않고 크고 작은 목표들을 달성해나갈 때마다 어느새 우리는 우리가
                        목표로 세웠던 방향에 도달할 수 있을 것입니다. 우리는 교육의 혁신을 이루어내고자 함께 모였으며,
                        앞으로도 우리는 계속해서 고민을 하고, 답을 찾을 것입니다. -->
                    </p>
                </div>
                <div style="position: relative; display: flex; flex-direction: column;">
                    <p style="font-size: 30px; font-weight: 700; color: white; text-align: left; color: #000000; margin-bottom: 50px; line-height: 1.5; z-index: 1">
                        사용자 만족도 1위,<br>
                        높은 만족도로<br>
                        빠르게 성장합니다.
                    </p>
                    <!-- <div v-else style="height: 200px"></div> -->
                    <div v-if="showGraph" data-aos="fade-up"
                        data-aos-delay="300"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out"
                        data-aos-id="count"
                        ref="userCount"
                        style="display: flex; flex-direction: column; z-index: 1">
                        <div style="display: flex; flex-direction: column; margin-bottom: 30px;">
                            <p style="width: 310px; font-size: 18px; font-weight: 700; color: black">누적 가입자 수</p>
                            <p style="font-size: 18px; font-weight: 400">{{comma(allUser)}} 명</p>
                        </div>
                        <div style="display: flex; flex-direction: column; margin-bottom: 20px;">
                            <p style="width: 310px; font-size: 18px; font-weight: 700; color: black">월 신규 가입자 수</p>
                            <p style="font-size: 18px; font-weight: 400">{{comma(monthUser)}} 명</p>
                        </div>
                        <p data-aos="fade-up"
                            data-aos-delay="250"
                            data-aos-once="true"
                            data-aos-duration="600"
                            data-aos-easing="ease-in-out" 
                            style="font-size: 15px; font-weight: 400; color: #CCCCCC">22년 11월 기준</p>
                    </div>
                    <div ref="graph" data-aos="fade-up"
                            data-aos-delay="0"
                            data-aos-once="true"
                            data-aos-duration="600"
                            data-aos-easing="ease-in-out" style="position: absolute; width: 100%; max-width: 100vw; top: 84px; right: 0; z-index: 0">
                        <transition name="fade">
                            <LineChart v-if="showGraph" :data="data" :info="chartData" :height="deviceHeight - 155" style="max-width: 100%" />
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
import LineChart from './LineChart'
export default {
    props: ['data'],
    components: {
        ChevronDownIcon,
        LineChart
    },
    data() {
        return {
            deviceHeight: 0,
            showGraph: false,
            allUser: 0,
            monthUser: 0,
            chartData: {
                size: 4,
                unit: [100 , 80 , 60 , 40 , 20, 0 ],
                series: [
                    {   
                        name: 'part_time',
                        data: [
                            { id: 1, day: '', date: '22.07', percent: 0, label: 0, height: null, width: null, rotate: null, active: false },
                            { id: 2, day: '', date: '22.08', percent: 10, label: 0, height: null, width: null, rotate: null, active: false },
                            { id: 3, day: '', date: '22.09', percent: 50, label: 0, height: null, width: null, rotate: null, active: false },
                            { id: 4, day: '', date: '22.10', percent: 60, label: 0, height: null, width: null, rotate: null, active: false },
                            { id: 5, day: '', date: '22.11', percent: 100, label: 0, height: null, width: null, rotate: null, active: false },
                        ],
                        style: {
                            circle: '12',
                            color:  '#1F9DD4',
                            border: '2px',
                        }
                    }
                ]
            },
        }
    },
    computed: {
        graph() {
            return this.$refs.graph
        },
        userCount() {
            return this.$refs.userCount
        },
    },
    watch: {
        showGraph() {
            if(!this.showGraph) return
            this.countStart()
        }
    },
    methods: {
        countStart() {
            setTimeout(() => {
                this.countAllMember(this.data[0])
                this.countMonthMember(this.data[1])
            }, 500);
        },
        countAllMember(index) {
            if(this.allUser == 0) {
                setInterval(() => {
                    if(this.allUser < index) {
                        this.allUser += 500
                        if((index - this.allUser) < 500) {
                            this.allUser += (index - this.allUser)
                        }
                    }
                }, 1);
            }
        },
        countMonthMember(index) {
            if(this.monthUser == 0) {
                setInterval(() => {
                    if(this.monthUser < index) {
                        this.monthUser += 100
                        if((index - this.monthUser) < 100) {
                            this.monthUser += (index - this.monthUser)
                        }
                    }
                }, 1);
            }
        },
        comma(val) {
            val = String(val)
            return val.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')
        },
        handleScroll() {
            // if(this.showGraph) {
            //     if(this.userCount.getBoundingClientRect().top < window.innerHeight) {
            //         this.countStart()
            //     }
            // }
            if(this.graph.getBoundingClientRect().top < (window.innerHeight / 2)) {
                this.showGraph = true
            }

        }
    },
    created() {
        document.addEventListener('scroll', this.handleScroll)
        this.deviceHeight = window.innerHeight
    },
    beforeDestroy() {
        document.removeEventListener('scroll', this.handleScroll)
    }, 
    
}
</script>
<style>
    .main_section2 {
        width: 100vw;
        height: 1277px;
        background: white;
        object-fit: inherit;
    }
    .main_section2 .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
</style>